export const countryToCurrency: Record<string, string> = {
  at: "EUR",
  au: "AUD",
  be: "EUR",
  ca: "CAD",
  cy: "EUR",
  de: "EUR",
  ee: "EUR",
  es: "EUR",
  fi: "EUR",
  fr: "EUR",
  gb: "GBP",
  gr: "EUR",
  hr: "EUR",
  ie: "EUR",
  it: "EUR",
  jp: "JPY",
  lt: "EUR",
  lu: "EUR",
  lv: "EUR",
  mt: "EUR",
  nl: "EUR",
  pt: "EUR",
  si: "EUR",
  sk: "EUR",
  us: "USD",
};

export type CurrencyCode = "AUD" | "CAD" | "EUR" | "GBP" | "JPY" | "USD";

export function getCurrencyForCountry(countryCode: string): CurrencyCode {
  return (
    (countryToCurrency[countryCode.toLowerCase()] as CurrencyCode) || "USD"
  );
}

export function getCountriesForCurrency(currency: string): string[] {
  const countries: string[] = [];

  for (const [country, curr] of Object.entries(countryToCurrency)) {
    if (curr === currency) {
      countries.push(country);
    }
  }

  return countries;
}
